import { h, Component } from 'preact';
import { configure } from '../../config';
import style from './style';
import { Text, MarkupText } from 'preact-i18n';
import { CcpaButtons } from '../ccpa-buttons';

export class CcpaPartnersWidget extends Component {

	buttonClicked = (partnerLink) => {
		if (partnerLink.external) {
			window.open(partnerLink.url, '_blank', 'noopener');
		}
		else {
			window.location.href = partnerLink.url;
		}
	}

	renderOriginalVersion({ partners, buttonLinks, intlFields }) {
		return (
			<div class={style.ccpa}>
				<div class={style.title}><Text id="partnersTitle" /></div>
				<div class={style.description}><Text id="partnersDescription" fields={intlFields} /></div>
				<div class={style.links}>
					{partners && partners.map((partner) =>
						(
							<a class={style.link} href={partner.url} target="_blank" rel="noopener noreferrer">
								{partner.text}
							</a>
						)
					)}
				</div>
				<div class={style.sectionTitle}><Text id="linksTitle" /></div>
				<CcpaButtons links={buttonLinks} />
			</div>);
	}

	render20201123Version({ partners, buttonLinks, intlFields }) {
		return (
			<div class={style.ccpa}>
				<div class={style.title}><Text id="20201123.partnersTitle" /></div>
				<div class={style.description}><MarkupText id="20201123.partnersDescription" fields={intlFields} /></div>
				<div class={style.links}>
					{partners && partners.map((partner) =>
						(
							<a class={style.link} href={partner.url} target="_blank" rel="noopener noreferrer">
								{partner.text}
							</a>
						)
					)}
				</div>
				<div class={style.sectionTitle}><Text id="20201123.partnersLiverampTitle" /></div>
				<div class={style.description}><MarkupText id="20201123.partnersLiverampDescription" fields={intlFields} /></div>
				<div class={style.sectionTitle}><Text id="20201123.linksTitle" /></div>
				<CcpaButtons links={buttonLinks} />
			</div>);
	}


	render({ partners, links, clientDisplayName, overrideVersion }, { }) {
		let buttonLinks = [links.main, links.data, links.privacy],
			hostname = window.location.hostname;

		let intlFields = { hostname, ccpaLinks: links, clientDisplayName };

		return overrideVersion === '20201123' ?
			this.render20201123Version({ buttonLinks, partners, intlFields }) :
			this.renderOriginalVersion({ buttonLinks, partners, intlFields });

	}
}

export const CcpaPartners = (configure({
	overrideVersion: 'privacyWidgetsConfig.overrideVersion',
	partners: 'privacyWidgetsConfig.ccpa.partners',
	links: 'privacyWidgetsConfig.ccpa.links',
	clientDisplayName: 'clientDisplayName'
})((props) =>  (
	<CcpaPartnersWidget {...props} />
)));
